<template>
    <div class="parent">
      <div class="div1">
        <img src="../assets/periogard/logo.png" alt="Imagen de prueba" />
      </div>
      <div class="div2">
        <img src="../assets/periogard/Ciclo2.png" alt="Imagen contenedor 2" class="img-contenedor2 fondo" />
        <img src="../assets/periogard/Textos 1_1.png" alt="Imagen encima" class="img-contenedor2 overlay" />
        <p class="texto-lateral">Inflamatorias <br> Influenciadas por: Factores <br> del hospedero, biopelícula <br> disbiótica, factores de riesgo</p>
      </div>
    </div>
  </template>
  
  <script>
  import { onMounted } from "vue";
  import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  
  export default {
    name: "ResponsiveGrid",
    setup() {
      onMounted(() => {
        gsap.fromTo(
          ".fondo",
          {
            x: "-100vw", // Sale desde la izquierda, fuera de la pantalla
            opacity: 0 // Aparece de forma gradual
          },
          {
            x: "0", // Aterriza en su posición original
            opacity: 1,
            duration: 4.5, // Aumentamos la duración para más suavidad
            ease: "power2.out", // Movimiento progresivo y natural
            scrollTrigger: {
              trigger: ".div2",
              start: "top 90%", // Inicia antes para que fluya mejor
              end: "top 20%", // Termina más tarde para más suavidad
              scrub: 2 // Ajustamos el scrub para que sea más progresivo
            }
          }
        );
      });
    }
  };
  </script>
  
  <style scoped>
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 50px;
    width: 100%;
    height: 80vh;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    /* background: url('../assets/periogard/Fondo_2.png') no-repeat; */
    background-color: #fff;
    background-position: center;
    background-size: cover;
  }
  
  /* Estilo base para cada div */
  .parent div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    color: white;
    text-align: center;
  }
  
  /* Contenedor 1 */
  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    min-height: auto;
    box-sizing: border-box;
    transform: translate(15%, 0);
  }
  
  .div1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Contenedor 2 con dos imágenes (una encima de la otra) */
  .div2 {
    grid-area: 2 / 4 / 7 / 10;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 418px;
    box-sizing: border-box;
    overflow: hidden;
  }
  
  /* Imagen de fondo */
  .div2 .fondo {
    width: 63%;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen encima */
  .div2 .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 98%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
  
  /* Texto pequeño alineado al lado izquierdo */
  .texto-lateral {
    position: absolute;
    left: 0%;
    top: 47%;
    transform: translateY(28%);
    font-family: 'ColgateReady-Italic';
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: gray;
    text-align: left;
  }
  
  /* Responsive para pantallas pequeñas */
  @media (max-width: 768px) {
    .parent {
      display: flex;
      flex-direction: column;
      height: auto;
    }
  
    .parent div {
      width: 100%;
      height: auto;
      min-height: 100px;
    }
  }
  </style>
  